<template>
	<v-container ref="fullPage" :style="darkTheme ? 'background-color: black;' : 'background-color: white;'" 
		fluid class="fullpage">
		
		<v-toolbar height="70" class="" >
			<v-layout justify-space-between align-center>
				<v-flex grow >
					<v-toolbar-title class="headline ">Reports</v-toolbar-title>
			  	</v-flex>
			  	<v-flex >
				  	<v-toolbar-title class="topTitle ">	
			  			<v-layout align-center row fill-height>			
							<img src="../../images/ua_block_rgb_3.3c82a4c.png" class="blocka">
							<a href="/" style="text-decoration: none;" :style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
								Interactive Floorplans 
							</a>
					 	</v-layout>
					</v-toolbar-title>	
				</v-flex>
				<v-flex shrink><DBToggleBtn/></v-flex>
				<v-flex shrink>
					<v-btn large icon class="grey--text text--darken-2" 
						@click="$router.push('/')">
						<v-icon large >close</v-icon>
					</v-btn>
				</v-flex>		
			</v-layout>
		</v-toolbar>


		<v-layout row class="mt-2" fill-height>
			<v-flex xs3> 	
				<v-card height="100%" class="mr-2 pa-4">								<!-- Left Side Column -->
					<AutocompleteDepartment 
	                class=""
					:key="resetAutoDept"
	                label="Select Department"      
	                style="width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" 
	                :prepend="'dns'" 
	                v-on:return-selection="selectDept" />

					<AutocompleteCollege 
	                class=""
					:key="resetAutoCollege"
	                label="Select College"      
	                style="width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top:10px;"          
	                :prepend="'dns'" 
	                v-on:return-selection="selectCollege" />
            	</v-card>
			</v-flex> 
			<v-flex :key="reset">														<!-- Right Side -->
				<v-card v-if="selectedDept" height="100%" class="pa-5">
					<v-layout  row justify-space-between>						
						<v-list-tile >
							<v-list-tile-avatar dark tile color="grey darken-3" class="smallerAvatar" style="color: white;">
			        			{{selectedDept.deptID}}
					        </v-list-tile-avatar>
					        <v-list-tile-content>
						        <v-list-tile-title>
						          	{{selectedDept.deptName}}
						        </v-list-tile-title>
						        <v-list-tile-sub-title v-text="`${selectedDept.collegeID} ${selectedDept.collegeName}`"></v-list-tile-sub-title>
					        </v-list-tile-content>					        
				    	</v-list-tile>

				    	<v-btn @click="clickReportEmployees" v-if="activeContent!='employee'">Employee Report</v-btn>	<!-- Report Buttons -->
				    </v-layout>
				    <v-layout class="ml-3 mt-5">										<!-- Dynamic Content -->
				    	<EmployeeReport v-if="activeContent=='employee'" v-on:refresh="refresh('employee')" />				
				    </v-layout>
				</v-card>
				<v-card v-if="selectedCollege" height="100%" class="pa-5">
					<v-layout  row justify-space-between>						
						<v-list-tile >
							<v-list-tile-avatar dark tile color="grey darken-3" class="smallerAvatar" style="color: white;">
			        			{{selectedCollege.id}}
					        </v-list-tile-avatar>
					        <v-list-tile-content>
						        <v-list-tile-title>
						          	{{selectedCollege.name}}
						        </v-list-tile-title>
					        </v-list-tile-content>					        
				    	</v-list-tile>

				    	<v-btn @click="clickReportEmployees" v-if="activeContent!='employee'">Employee Report</v-btn>	<!-- Report Buttons -->
				    </v-layout>
				    <v-layout class="ml-3 mt-5">										<!-- Dynamic Content -->
				    	<EmployeeReport v-if="activeContent=='employee'" v-on:refresh="refresh('employee')" />				
				    </v-layout>
				</v-card>
			</v-flex>
		
       	</v-layout>
	</v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import AutocompleteDepartment from '@/components/forms/AutocompleteDepartment.vue'
import AutocompleteCollege from '@/components/forms/AutocompleteCollege.vue'
import EmployeeReport from './reports/EmployeeReport'
import DBToggleBtn from '../DBToggleBtn'

export default {
data () {
	return {
		activeContent: null,
		reset: 1,
		resetAutoCollege: 100,
		resetAutoDept: 200
	}
},

created: function () {
	console.log("Dashboard")
},

components: { AutocompleteDepartment, EmployeeReport, DBToggleBtn, AutocompleteCollege },

computed: {
	...mapState({   	darkTheme: 			state => state.ui.darkTheme,
						selectedDept:		state => state.dashboard.selectedDept,
						selectedCollege:	state => state.dashboard.selectedCollege, })
},

methods : {
	...mapMutations([ 	'setSelectedDept', 'setEmployees', 'setSelectedCollege', 		]),	
	...mapActions([		'fetchDeptOccupantPIs',	'fetchCollegeOccupantPIs'							]),

	selectDept : function (value) {
		this.setSelectedCollege(null)
		this.resetAutoCollege++
		this.setSelectedDept(value)
		this.reset=this.reset+1
		this.activeContent=null
	},

	selectCollege : function (value) {
		this.setSelectedDept(null)
		this.resetAutoDept++
		this.setSelectedCollege(value)
		this.reset=this.reset+1
		this.activeContent=null
	},

	clickReportEmployees : function () {
		this.activeContent="employee"
		if (this.selectedDept) {
			this.fetchDeptOccupantPIs(this.selectedDept.deptID)
		}
		else {
			this.fetchCollegeOccupantPIs(this.selectedCollege.id)
		}
	},

	refresh: function(reportName) {
		if (reportName == "employee") { console.log("Refresh Employee Report"); this.clickReportEmployees() }
	},
},

}

</script>

<style>
.fullpage {
	display: absolute;
	flex-direction: column;
	flex: 1;
	z-index: 10;
	position: fixed;
	top: 0px;
	width: 100vw;
	background-color: rgba(255, 255, 255, 1);
	padding: 0px !important;
	margin-top: 0px;
	height: 100%;
	overflow: hidden;
}

.topTitle {
	font-family: 'Open Sans', sans-serif;
	font-size: 25px;
}

.blocka {
  height: 45px;
  margin-right: 20px;
  margin-left: 20px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Dashboard.vue